import * as Highcharts from 'highcharts';
import * as jQuery from 'jquery';
import * as _ from 'underscore';

import {
	AfterViewInit,
	Component,
	ElementRef,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChanges,
	ViewChild
} from '@angular/core';

import { UtilityService } from '../../../../core/utility/services/utility.service';

@Component({
	selector: 'app-half-donut',
	styleUrls: ['./half-donut.component.css'],
	templateUrl: './half-donut.component.html'
})
export class HalfDonutComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
	@ViewChild('chartElement', { static: true }) chartElement: ElementRef;
	@ViewChild('donutLegendElement') legendElement: ElementRef;

	@Input() chartData: any;
	@Input() seriesName: string;
	@Input() innerSize: string;
	@Input() dataLabelsDistance;
	@Input() showInLegend;
	@Input() size;
	@Input() verticalAlign;
	@Input() xLegendPos;
	@Input() yLegendPos;
	@Input() legendItemDistance;
	@Input() height;
	@Input() legendText;
	@Input() margin;
	@Input() lineBreak;
	@Input() svgWidth;
	@Input() svgHeight;
	@Input() legendFloating;
	@Input() datalabelsEnabled;
	@Input() legendWidth: any;
	@Input() isTooltipEnabled;
	@Input() type;
	@Input() enableCustomLegend = false;
	@Input() customLegendData: any;
	@Input() legendLayout;
	@Input() enableDataLabels;

	public hasData = true;
	public chartObj: any;
	private seriesData: any;
	private pieObj = {};
	private startAngle = -90;
	private endAngle = 90;

	constructor() {}

	ngOnInit(): void {}

	ngAfterViewInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['chartData'] || changes['svgWidth'] || changes['svgHeight']) {
			if (this.chartData) {
				if (this.chartData.length > 0) {
					this.drawDonutChart();
				}
			}
		}
	}

	ngOnDestroy(): void {
		if (this.chartObj) {
			this.chartObj.destroy();
		}
	}

	setUpPieObj(): void {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		this.seriesData = [
			{
				data: this.chartData,
				name: UtilityService.upperCaseFirst(this.seriesName)
			}
		];
		this.pieObj = {
			center: ['50%', '50%'],
			dataLabels: {
				distance: 5,
				enabled: this.enableDataLabels,
				format: '<b>{point.name}</b>: {point.percentage:.1f} %'
			},
			endAngle: this.endAngle ? this.endAngle : null,
			innerSize: '50%',
			showInLegend: true,
			size: '100%',
			startAngle: this.startAngle ? this.startAngle : 0
		};
	}

	drawDonutChart(): void {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		this.seriesData = {};
		if (typeof this.isTooltipEnabled === 'undefined') {
			this.isTooltipEnabled = true;
		}
		this.setUpPieObj();
		Highcharts.setOptions({
			lang: {
				thousandsSep: ','
			}
		});

		this.chartObj = Highcharts.chart({
			chart: {
				backgroundColor: 'transparent',
				height: this.svgHeight,
				margin: this.margin || [40, 10, 10, 10],
				renderTo: this.chartElement.nativeElement,
				type: 'pie',
				width: this.svgWidth
			},
			credits: {
				enabled: false
			},
			legend: {
				align: 'center',
				enabled: !this.enableCustomLegend,
				floating: UtilityService.isUndefined(this.legendFloating) ? true : this.legendFloating,
				itemDistance: this.legendItemDistance || 20,
				itemMarginBottom: 10,
				itemMarginTop: 15,
				itemStyle: {
					fontSize: '12px',
					fontWeight: '100'
				},
				// tslint:disable-next-line: object-literal-shorthand
				labelFormatter: function (): string {
					let legendText = self.legendText;
					legendText = legendText ? legendText : '';
					return `${this.name}${legendText} ${this['percentage'].toFixed(1)}%`;
				},
				verticalAlign: this.verticalAlign || 'top',
				x: this.xLegendPos || -15,
				y: this.yLegendPos || -50
			},
			plotOptions: {
				pie: this.pieObj
			},
			responsive: {
				rules: [
					{
						chartOptions: {
							legend: {
								enabled: true,
								itemMarginBottom: -7,
								y: -70
							}
						},
						condition: {
							maxWidth: 700
						}
					},
					{
						chartOptions: {
							legend: {
								enabled: true,
								y: -120
							}
						},
						condition: {
							minWidth: 800
						}
					}
				]
			},
			series: this.seriesData,
			subtitle: {
				text: ''
			},
			title: {
				text: ''
			},
			tooltip: {
				backgroundColor: '#000',
				borderRadius: 10,
				borderWidth: 0,
				enabled: true,
				// tslint:disable-next-line: object-literal-shorthand
				formatter: function (): string {
					return `<b>${this.percentage.toFixed(1)}% (${this.y})</b><br/><div><span style="color: ${
						this.color
					}; font-size:20px">● </span> ${this.key}</div>`;
				},
				padding: 15,
				shadow: false,
				style: {
					color: '#fff',
					fontSize: '14px'
				},
				useHTML: true
			}
		});
		jQuery(this.chartObj.container).css('margin', '0 auto');
	}

	updateLegendArray(legendItem: any): void {
		const legendObj: any = _.findWhere(this.customLegendData, { index: legendItem.index });
		if (legendObj) {
			legendObj.active = !legendObj.active;
		}
		this.updateSeriesObj();
	}

	updateSeriesObj(): void {
		if (this.type === 'pieDonut') {
			const selectedLegendItems = _.where(this.customLegendData, { active: true });
			const selectedIndexes = _.pluck(selectedLegendItems, 'index');
			const chartData = JSON.parse(JSON.stringify(this.chartData));
			for (const chartObj of chartData) {
				chartObj.data = _.filter(chartObj.data, (obj: any, index) => {
					return _.indexOf(selectedIndexes, index) !== -1;
				});
			}
			for (let i = 0; i < chartData.length; i++) {
				this.chartObj.series[i].update(chartData[i]);
			}
		}
	}
}
